// src/processors/template/index.ts - Template Module Exports
import {ProcessResult} from "../../types/process-options";

export { TemplateProcessor } from './template-processor';
export { TemplateContentProcessor } from './template-content-processor';
export { TemplateSourceMapProcessor } from './template-sourcemap-processor';
export { TemplateFileHandler } from './template-file-handler';

// Convenience function for backward compatibility
import { XConVitePluginOptions } from '../../types';
import { TemplateProcessor } from './template-processor';
import {Logger} from "../../utils/logger";

/**
 * Process templateUrl -> template conversion (backward compatibility function)
 */
export function processTemplateUrl(
    code: string,
    id: string,
    options: Required<XConVitePluginOptions>,
    addWatchFile: (file: string) => void,
    logger: Logger
): ProcessResult & { map?: any } {
    const processor = new TemplateProcessor(options, logger);
    return processor.processTemplateUrl(code, id, addWatchFile);
}